import { Controller } from "@hotwired/stimulus"
import Fuse from "fuse.js"

export default class extends Controller {
  static targets = ["filter", "recipe"]

  connect() {
    this.cyrillicMap = {
      'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd',
      'е': 'e', 'ё': 'e', 'ж': 'zh', 'з': 'z', 'и': 'i',
      'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n',
      'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't',
      'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'ts', 'ч': 'ch',
      'ш': 'sh', 'щ': 'sht', 'ъ': 'a', 'ы': 'y', 'ь': 'y',
      'э': 'e', 'ю': 'yu', 'я': 'ya'
    }

    this.latinToCyrillicMap = {
      'sht': 'щ', 'sh': 'ш', 'ch': 'ч', 'zh': 'ж',
      'ts': 'ц', 'yu': 'ю', 'ya': 'я',
      'a': 'а', 'b': 'б', 'v': 'в', 'g': 'г', 'd': 'д',
      'e': 'е', 'z': 'з', 'i': 'и', 'y': 'й', 'k': 'к',
      'l': 'л', 'm': 'м', 'n': 'н', 'o': 'о', 'p': 'п',
      'r': 'р', 's': 'с', 't': 'т', 'u': 'у', 'f': 'ф',
      'h': 'х'
    }

    const recipes = this.recipeTargets.map((target) => {
      return {
        term: target.dataset.filterBy,
        element: target
      }
    })

    this.fuse = new Fuse(recipes, {
      includeScore: true,
      threshold: 0.3,
      keys: ["term"]
    })
  }

  transliterate(text) {
    return text.split('').map(char => this.cyrillicMap[char.toLowerCase()] || char).join('')
  }

  reverseTransliterate(text) {
    let result = text.toLowerCase()
    const keys = Object.keys(this.latinToCyrillicMap).sort((a, b) => b.length - a.length)
    keys.forEach(latin => {
      result = result.replace(new RegExp(latin, 'g'), this.latinToCyrillicMap[latin])
    })
    return result
  }

  filter() {
    const query = this.filterTarget.value

    if (query == "") {
      this.showAll()
    } else {
      this.hideAll()

      const original = query
      const toLatin = this.transliterate(query)
      const toCyrillic = this.reverseTransliterate(query)

      const allMatches = new Set()

      ;[original, toLatin, toCyrillic].forEach(searchTerm => {
        this.fuse
          .search(searchTerm)
          .forEach((match) => allMatches.add(match.item.element))
      })

      allMatches.forEach(element => element.classList.remove("hidden"))
    }
  }

  hideAll() {
    this.recipeTargets.forEach((target) => target.classList.add("hidden"))
  }

  showAll() {
    this.recipeTargets.forEach((target) => target.classList.remove("hidden"))
  }
}
